import { Component, inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/services/login/login.service';
import { SweetServices } from 'src/services/sweet.services';
import { AppComponent } from '../../app.component';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})

export class ResetPassComponent {
  selectedLanguage = environment.lang;
  public lang: string = environment.lang;
  public traduccion = environment.traduccion;
  version = environment.version
  private loadingService = inject(LoadingService);

  constructor(
    private alerta: SweetServices,
    private loginService: LoginService,
    private router: Router
  ) {
  }

  resetpassForm = {
    Login: '',
    Password: '',
    Bloqueo: false,
    version: environment.version
  };

  //Validar en un futuro quitar formResetpass
  submitResetpass(evt: Event) {
    evt.preventDefault();
    this.loadingService.mostrar();
    if (this.resetpassForm.Login === '') {
      this.loadingService.ocultar();
      this.alerta.AlertaErrorTimer('Llena el Formulario');
    } else {
      this.loginService.emailRestablecerPassword(this.resetpassForm).subscribe(response => {
        if (response === null) {
          this.loadingService.ocultar();
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        } else if (response.isCorrect === 'false') {
          this.loadingService.ocultar();
          this.alerta.AlertaError(response.message);
        } else {
          this.correctResetpass();
        }
      }, (err) => {
        this.loadingService.ocultar();
        this.alerta.AlertaCatch(err);
      }
      );
    }
  }

  private correctResetpass() {
    this.loadingService.ocultar();
    this.alerta.AlertaSuccessTimer(
      "Se ha enviado un correo para procesar su solicitud de cambio de contraseña.");
    this.goLogin();
  }

  goLogin() {
    this.router.navigate(['/', 'login']);
  }

  public cancelar() {
    this.goLogin();
  }

  prevenirPegado(evt: Event) {
    if(environment.production){
      evt.preventDefault();
    }
  }
}
